import React from 'react';
const bonuses = [{
  emoji: '⚽',
  title: "Guide d'Échauffement Spécifique",
  desc: 'Routines pour activer et prévenir les blessures.'
}, {
  emoji: '📅',
  title: 'Plan Annuel Express',
  desc: 'Une feuille de route prête pour organiser votre agenda de compétition.'
}, {
  emoji: '✅',
  title: "Fiches d'Évaluation",
  desc: 'Auto-évaluations pour que vos joueurs mesurent leur progrès.'
}, {
  emoji: '🥗',
  title: 'Guide Nutrition Basique',
  desc: 'Quoi manger avant et après chaque match.'
}, {
  emoji: '🏆',
  title: 'Certificat Professionnel',
  desc: 'Pour attester de votre formation à la méthodologie EDULABS.'
}, {
  emoji: '📝',
  title: 'Règlement Intérieur Type',
  desc: "Document prêt à signer pour professionnaliser l'engagement de l'équipe."
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="text-center mb-14" data-id="element-16">
          <span className="inline-block text-secondary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-17">
            🔥 6 Bonus Inclus
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-18">
            Ajoutez ces extras{' '}
            <span className="text-secondary" data-id="element-19">sans payer plus</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg font-medium" data-id="element-20">
            Valeur :{' '}
            <span className="text-badge-red font-black line-through" data-id="element-21">39 €</span>{' '}
            — Gratuits Aujourd'hui
          </p>
        </div>

        <div className="space-y-4" data-id="element-22">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt/80 backdrop-blur-sm rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-secondary/30 hover:shadow-[0_10px_30px_rgba(245,158,11,0.1)] group" data-id="element-23">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-24">
                {bonus.emoji}
              </div>

              <div className="flex-1 min-w-0" data-id="element-25">
                <h4 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-26">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-27">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-28">
                GRATUIT
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}